import { render, staticRenderFns } from "./HeaderForm.vue?vue&type=template&id=4073be51&scoped=true&"
import script from "./HeaderForm.vue?vue&type=script&lang=js&"
export * from "./HeaderForm.vue?vue&type=script&lang=js&"
import style0 from "./HeaderForm.vue?vue&type=style&index=0&id=4073be51&scoped=true&lang=scss&"
import style1 from "./HeaderForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4073be51",
  null
  
)

export default component.exports